var View = require('views/base/view');
var TimeoutService = require('services/timeout-service');


var MultiTapSelectionQuestionView = View.extend({
  autoRender: true,
  template: require('./templates/multi-tap-selection-question'),

  activitySettings: undefined,

  questionDelayTimeout: null,
  questionSelectionTimeout: null,

  questionAnswered: false,

  questionElements:undefined,

  regions: {},

  load: function() {
    this.activitySettings = this.model.get('activitySettings');
    this.regions = this.model.get('regions');
    this.initializeQuestion();
  },

  dispose: function() {
    this.clearQuestionTimers();
    View.prototype.dispose.apply(this, arguments);
  },

  // sets/renders a question based on the current position of the question iterator
  initializeQuestion: function() {
    let answers = this.model.get('answers');
    this.model.set('answers', answers);
    this.questionElements = $(this.regions.question+' .question-answer');
    for(var i = 0; i < this.questionElements.length; i++) {
      $(this.questionElements[i]).attr('answerid', answers[i].id).addClass('answer-'+i);
    }
    this.startQuestionTimers();
    this.delegate('click', '.question-answer', (e)=>{this.selectElement(e);});
    this.delegate('click', '.multi-tap-submit-button', ()=>{this.answerQuestion();});
    this.questionAnswered = false;
  },

  // clear timeouts and intervals if they exist
  clearQuestionTimers: function() {
    if(this.questionDelayTimeout !== null) {
      this.questionDelayTimeout.clear();
    }
    if(this.questionSelectionTimeout !== null) {
      this.questionSelectionTimeout.clear();
    }
  },


  // kick off timers with the start of a new question
  startQuestionTimers: function() {
    if(this.activitySettings.question_timeout !== -1) {
      this.questionSelectionTimeout = new TimeoutService(this.activitySettings.question_timeout,
        ()=>{
          this.questionTimeout();
        });
      this.questionSelectionTimeout.play();
    }
  },

  // timeout that registers if the user takes too long to answer
  questionTimeout: function() {
    this.clearQuestionTimers();

    $(this.regions.question).addClass('unanswered incorrect');
    this.questionElements.removeClass('selected');
    this.applyAnswerClasses();

    this.trigger('question:timeout', {
      feedback: this.model.get('feedback'),
      answerElement: $('.game-container')
    });
  },

  // apply selection class to element
  selectElement: function(e) {
    let elem = $(e.currentTarget);
    if(this.activitySettings.one_at_a_time) {
      let aIndex = elem.attr('answerid');
      for(var i = 0; i < this.questionElements.length; i++) {
        let qElem = $(this.questionElements[i]);
        if(qElem.attr('answerid') !== aIndex) {
          qElem.removeClass('selected');
        }
      }
    }
    elem.toggleClass('selected');
  },

  // fired when the submit button is clicked, checks the answer selected
  answerQuestion: function(e) {
    this.$el.off('click', '.multi-tap-submit-button');
    this.$el.off('click', '.question-answer');

    let sArray = $('.selected');
    if(sArray.length < 1) return;

    let aArray = [];
    for(var i = 0; i < sArray.length; i++) {
      aArray.push(parseInt($(sArray[i]).attr('answerid'),10));
    }
    aArray.sort(function(a, b) {return a-b;});

    this.clearQuestionTimers();

    let correct = this.checkQuestionCorrect(aArray);

    $(this.regions.question).addClass(`answered ${correct === true?'correct':'incorrect'}`);

    this.applyAnswerClasses();

    this.question_timeout = new TimeoutService(this.activitySettings.question_delay,
      ()=>{
        this.trigger('question:feedback', {
          correct: correct,
          feedback: this.model.get('feedback'),
          answerElement: $('.game-container')
        });
      });

    this.question_timeout.play();

    this.trigger('question:answered', {
      correct: correct
    });
  },

  // apply classes to the answer elements based on whether they are inherently correct
  applyAnswerClasses: function() {
    this.model.get('answers').forEach((e, i)=>{
      if(_.indexOf(this.model.get('correct'), e.id) !== -1) {
        $(this.questionElements[i]).addClass('correct');
      } else {
        $(this.questionElements[i]).addClass('incorrect');
      }
    });
  },

  // is the selected answer correct?
  checkQuestionCorrect: function(selectedAnswer) {
    if(this.activitySettings.any_correct) {
      let containsIncorrect = false;
      let correctAnswers = this.model.get('correct').sort(function(a, b) {return a-b;}).join('').toString();
      for(var i = 0; i < selectedAnswer.length; i++) {
        let a = selectedAnswer[i].toString();
        if(correctAnswers.indexOf(a) === -1) {
          containsIncorrect = true;
        }
      }
      return !containsIncorrect;
    } else {
        let correct = this.model.get('correct').sort(function(a, b) {return a-b;}).join('').toString();
        let check = selectedAnswer.join('').toString();
        return check === correct;
    }

  }
});

module.exports = MultiTapSelectionQuestionView;
